<script>
  import {
    VSpacer
  } from 'vuetify/lib'
  export default {
    name: 'wh-spacer',
    extends: VSpacer
  };
</script>